import directive from 'components/form/validator/directive';

/**
 * Simple plugin to add the field directive for Vue.js
 * @param Vue
 */
const runPlugin = (Vue) => {
    Vue.directive('field-control', directive);
};

export default {
    install: runPlugin,
};



// WEBPACK FOOTER //
// ./src/components/form/validator/index.js